import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Stack, Text, Title, TextInput, Button, Paper, Anchor } from '@mantine/core'
import { IconMail, IconCheck } from '@tabler/icons-react'
import { useAuth } from '../hooks/useAuth'

const inputStyles = {
  input: {
    background: 'rgba(10, 22, 40, 0.8)',
    border: '1px solid rgba(0, 255, 255, 0.15)',
    color: '#e0e8f0',
  },
  label: { color: 'var(--mantine-color-gray-4)' },
}

export default function ForgotPassword() {
  const navigate = useNavigate()
  const { requestPasswordReset } = useAuth()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!email.trim()) return

    setLoading(true)
    setError('')

    const result = await requestPasswordReset(email.trim())
    setLoading(false)

    if (result.success) {
      setSent(true)
    } else {
      setError(result.error)
    }
  }

  return (
    <Container size="xs" py="xl">
      <Stack align="center" gap="lg" style={{ minHeight: '50vh', justifyContent: 'center' }}>
        <Title order={2} ff="Orbitron, sans-serif" c="cyan.4">
          Reset Password
        </Title>

        {sent ? (
          <Paper p="xl" className="glass" w="100%">
            <Stack align="center" gap="md">
              <IconCheck size={48} color="var(--mantine-color-cyan-4)" />
              <Text c="gray.3" ta="center">
                Check your email for reset instructions. If you don't see it, check your spam folder.
              </Text>
            </Stack>
          </Paper>
        ) : (
          <>
            <Text c="dimmed" ta="center" maw={360}>
              Enter your email address and we'll send you instructions to reset your password.
            </Text>

            <Paper p="xl" className="glass" w="100%">
              <form onSubmit={handleSubmit}>
                <Stack gap="md">
                  <TextInput
                    label="Email"
                    placeholder="your@email.com"
                    leftSection={<IconMail size={16} />}
                    value={email}
                    onChange={(e) => setEmail(e.currentTarget.value)}
                    type="email"
                    required
                    error={error}
                    styles={inputStyles}
                  />

                  <Button type="submit" loading={loading} fullWidth size="md">
                    Send Reset Instructions
                  </Button>
                </Stack>
              </form>
            </Paper>
          </>
        )}

        <Text size="sm" c="dimmed">
          Remember your password?{' '}
          <Anchor c="cyan.4" onClick={() => navigate('/login')}>
            Log in
          </Anchor>
        </Text>
      </Stack>
    </Container>
  )
}
